var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Upload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3333 43.9567H26.6666C25.1999 43.9567 23.9999 42.7567 23.9999 41.2901V27.9567H19.7599C17.3866 27.9567 16.2133 25.0767 17.8933 23.3967L30.1333 11.1567C30.6315 10.6574 31.3079 10.3768 32.0133 10.3768C32.7186 10.3768 33.395 10.6574 33.8933 11.1567L46.1333 23.3967C47.8133 25.0767 46.6133 27.9567 44.2399 27.9567H39.9999V41.2901C39.9999 42.7567 38.7999 43.9567 37.3333 43.9567ZM47.9999 49.2901H15.9999C14.5333 49.2901 13.3333 50.4901 13.3333 51.9567C13.3333 53.4234 14.5333 54.6234 15.9999 54.6234H47.9999C49.4666 54.6234 50.6666 53.4234 50.6666 51.9567C50.6666 50.4901 49.4666 49.2901 47.9999 49.2901Z",
    fill: "#737188"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.e938304a8e2acd27b865385a9ada6780.svg";
export { ForwardRef as ReactComponent };